export default {
  meta: {
    title: '查询历史',
    url: '/spotevaluation', // 埋点用，记录所属模块
    parentPath: ['/spotevaluation'],
    breadcrumbs: {
      path: ['/spotevaluation'], // 该模块首页
      name: ['点位测评'],
    },
  },
};
